/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'feedback-collector.anonymous': 'Ta opinia jest przekazywana anonimowo. Firma Atlassian nie będzie mogła kontaktować się z Tobą bezpośrednio w sprawie tej opinii',
  'feedback-collector.anonymous.title': 'Opinia anonimowa',
  'feedback-collector.can-be-contacted.label': 'Tak, zespoły Atlassian mogą się ze mną kontaktować, aby poznać moją opinię i na jej podstawie ulepszać produkty oraz usługi Atlassian. Potwierdzam, że znam <a>Politykę prywatności Atlassian</a>.',
  'feedback-collector.cancel-button.label': 'Anuluj',
  'feedback-collector.default.custom.textarea.label': 'Jakie spostrzeżenia chcesz przekazać?',
  'feedback-collector.enrol-in-research.label': 'Chcę uczestniczyć w badaniach nad produktem',
  'feedback-collector.feedback-title': 'Podziel się swoimi przemyśleniami',
  'feedback-collector.form.bug.label': 'Opisz błąd lub problem',
  'feedback-collector.form.comment.label': 'Poinformuj nas, w czym problem',
  'feedback-collector.form.empty.label': 'Wybierz opcję',
  'feedback-collector.form.question.label': 'Czego chcesz się dowiedzieć?',
  'feedback-collector.form.suggestion.label': 'Daj nam znać, co chcesz poprawić',
  'feedback-collector.option.bug.label': 'Zgłosić błąd',
  'feedback-collector.option.comment.label': 'Pozostaw komentarz',
  'feedback-collector.option.default.label': 'Wybierz opinię',
  'feedback-collector.option.default.placeholder': 'Wybierz jedną',
  'feedback-collector.option.question.label': 'Zadać pytanie',
  'feedback-collector.option.suggestion.label': 'Zasugerować ulepszenie',
  'feedback-collector.required.fields.summary': 'Pola wymagane są oznaczone gwiazdką',
  'feedback-collector.submit-button.label': 'Prześlij opinię',
  'feedback-collector.success-flag.description': 'Wartościowe opinie użytkowników pomagają nam stale doskonalić nasze produkty.',
  'feedback-collector.success-flag.title': 'Dziękuję!',
  'feedback-collector.summary-placeholder': 'Poinformuj nas, w czym problem',
  'proforma-form-builder.feedback-icon-label': 'Opinia',
  'proforma-form-builder.give-feedback': 'Przekaż opinię'
};